import { isLocalStorageAvailable } from '@ott/utility-localstorage';

const DAY_TIME = 86400000;

/** route - новый роут */
/** key - ключ в localStorage */
/** count - сколько значений сохранять */
/** checkFunction(routes, newRoute) - ф-я в которой фильтруются устаревшие значения и дубликаты */
export function saveSearchRouteInLocalStorage(route, key, count, checkFunction) {
  if (!isLocalStorageAvailable) {
    return null;
  }

  const item = localStorage.getItem(key);

  const searchHistoryRoutes = item ? JSON.parse(item) : [];

  if (searchHistoryRoutes.length >= 10) {
    const lastIndex = searchHistoryRoutes.length - 1;
    searchHistoryRoutes.splice(lastIndex);
  }

  const filteredRoutes = checkFunction(searchHistoryRoutes, route);

  filteredRoutes.unshift(route);
  localStorage.setItem(key, JSON.stringify(filteredRoutes));
}

/** key - ключ в localStorage */
/** count - сколько значений загружать */
/**   0 - берем 1е как initialValues для формы */
/**   n > 0 - берем n для отображения в SearchHistory */
/** checkFunction(routes) - ф-я в которой фильтруются устаревшие значения и дубликаты */
export function getRoutesFromLocalStorage(key, count, checkFunction) {
  if (!isLocalStorageAvailable) {
    return [];
  }

  try {
    const item = localStorage.getItem(key);

    const searchHistoryRoutes = item ? JSON.parse(item) : [];
    const filteredRoutes = checkFunction(searchHistoryRoutes);

    localStorage.setItem(key, JSON.stringify(filteredRoutes));

    if (count) {
      return filteredRoutes.slice(1, count + 1);
    } else {
      return filteredRoutes.slice(0, 1);
    }
  } catch (e) {
    return [];
  }
}

export const checkSearchHistoryFromStorage = searchHistoryRoutes => {
  const now = Date.now();

  return searchHistoryRoutes.filter(item => {
    const startDate = new Date(item.route.fromDate).getTime();
    return now - startDate <= DAY_TIME;
  });
};
